import React from 'react'
import OrderTable from './Orders/OrderTable'

const Orders = () => {
  return (
    <OrderTable />
  )
}

export default Orders